import React from 'react'

import { SvgProps } from './types'

function StopCompareSvg({
  width,
  height,
  className,
  size,
  styles,
  stroke,
  strokeColor,
  fill,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      width={width || '48'}
      height={height || '48'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 .5 19 19"
      fill={fill}
    >
      <path
        d="M17.2832 18.2578L1.77686 2.75146"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path
        d="M10 18.333L10 1.66634"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path
        d="M10.0002 17.0469H4.7002C3.7337 17.0469 2.9502 16.2634 2.9502 15.2969L2.9502 3.9617"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        fill="none"
      />
      <path d="M10.7295 16.2471C11.1713 16.2471 11.5293 16.605 11.5293 17.0469C11.5293 17.4887 11.1713 17.8467 10.7295 17.8467H9.3584C8.91657 17.8467 8.55859 17.4887 8.55859 17.0469C8.55859 16.605 8.91657 16.2471 9.3584 16.2471H10.7295Z" />
      <path
        d="M16.0244 15.9912C16.3076 16.3113 16.7923 16.8702 17.0098 17.124L17.041 17.1611L17.0049 17.1934C16.6139 17.5451 16.1132 17.7778 15.5605 17.834H15.5586L15.3027 17.8467H13.9287C13.4869 17.8467 13.1289 17.4887 13.1289 17.0469C13.1289 16.6841 13.3703 16.3783 13.7012 16.2803L13.8477 16.251H13.8496L13.9258 16.2471H15.2979L15.3975 16.2422L15.5537 16.2129C15.7051 16.171 15.8412 16.0923 15.9521 15.9873L15.9902 15.9521L16.0244 15.9912Z"
        stroke="none"
      />
      <path
        d="M17.0537 13.2822C17.4955 13.2822 17.8535 13.6402 17.8535 14.082C17.8535 14.5215 17.5006 14.8936 17.0537 14.8936C16.6069 14.8936 16.2539 14.5215 16.2539 14.082C16.2539 13.6402 16.6119 13.2822 17.0537 13.2822Z"
        stroke="none"
      />
      <path
        d="M17.2012 7.99023C17.5446 8.05604 17.8099 8.34225 17.8457 8.69531V8.69727L17.8496 8.77344V11.2217C17.8496 11.6358 17.5351 11.9765 17.1318 12.0176L17.0498 12.0215C16.608 12.0214 16.25 11.6635 16.25 11.2217V8.77344L16.2539 8.69727V8.69531L16.2832 8.54883C16.3814 8.21807 16.6872 7.97659 17.0498 7.97656L17.2012 7.99023Z"
        stroke="none"
      />
      <path
        d="M15.2998 2.15234C16.7081 2.15234 17.8496 3.29382 17.8496 4.70215V5.9248C17.8494 6.33867 17.535 6.67959 17.1318 6.7207L17.0498 6.72461C16.6081 6.72457 16.2503 6.36634 16.25 5.9248V4.70215C16.25 4.17748 15.8245 3.75195 15.2998 3.75195H13.9287C13.487 3.7519 13.1291 3.39376 13.1289 2.95215L13.1328 2.87012C13.1739 2.46685 13.5146 2.15239 13.9287 2.15234H15.2998Z"
        stroke="none"
      />
      <path d="M10.7295 2.15234C11.1436 2.15234 11.4843 2.46682 11.5254 2.87012L11.5293 2.95215C11.5291 3.39379 11.1712 3.75195 10.7295 3.75195H9.3584C8.91676 3.75185 8.55878 3.39374 8.55859 2.95215L8.5625 2.87012C8.60359 2.46687 8.94437 2.15244 9.3584 2.15234H10.7295Z" />
      <path
        d="M9.99986 2.95215L5.88477 2.95215"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default StopCompareSvg
